import { useEffect } from 'react';
import I18n from 'I18n';
import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';
import { AIReconnectModal } from './AIReconnectModal';
import { openNewWindow } from '../../utils/popupUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const AIServiceComponent = ({
  metadata,
  onAuthCancelled,
  onAuthSucceeded,
  onAuthFailed,
  reconnectStarted,
  url
}) => {
  const appId = metadata === null || metadata === void 0 ? void 0 : metadata.appId;
  const status = metadata === null || metadata === void 0 ? void 0 : metadata.status;
  const isSunset = status === AppConnectionStatuses.SUNSET || status === AppConnectionStatuses.UPCOMING_SUNSET;
  useEffect(() => {
    // todo the point of discussion with Mark - it is not a reconnect, the button just opens a page from KB
    if (reconnectStarted && isSunset) {
      if (url) {
        openNewWindow(url);
      } else {
        onAuthFailed === null || onAuthFailed === void 0 || onAuthFailed({
          error: new Error('Failed to open the popup window. Url is missing.'),
          errorMessage: I18n.text('reconnect.errors.urlIsMissing')
        });
      }
    }
  }, [reconnectStarted, isSunset, url, onAuthFailed]);
  const handleCancel = () => {
    onAuthCancelled === null || onAuthCancelled === void 0 || onAuthCancelled({
      message: I18n.text('reconnect.warnings.reconnectionCancelled')
    });
  };
  const handleError = () => {
    onAuthFailed === null || onAuthFailed === void 0 || onAuthFailed({
      error: new Error('Reconnection failed'),
      errorMessage: I18n.text('reconnect.errors.reconnectFailed'),
      queryParams: new URLSearchParams(window.location.search).toString()
    });
  };
  const handleComplete = __apiKey => {
    onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded('completed');
  };
  return reconnectStarted && !isSunset ? /*#__PURE__*/_jsx(AIReconnectModal, {
    appId: appId,
    onClose: handleCancel,
    onSuccess: handleComplete,
    onFailure: handleError
  }) : null;
};